import { render, staticRenderFns } from "./MasterInstallations.vue?vue&type=template&id=08ef5a48&"
import script from "./MasterInstallations.vue?vue&type=script&lang=js&"
export * from "./MasterInstallations.vue?vue&type=script&lang=js&"
import style0 from "./MasterInstallations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports